var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"testAlertList"},_vm._l((_vm.alerts),function(alert,alertIndex){return _c('v-alert',{key:'alert' + alertIndex,attrs:{"type":alert.status,"dismissible":alert.dismissible,"dense":""}},[_vm._v(" "+_vm._s(alert.message)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }